<template>
    <div class="w3-container" id="services" style="margin-top:75px">
     <h1 class="w3-xxxlarge w3-text-blue"><b>Services.</b></h1>
     <hr style="width:50px;border:5px solid blue" class="w3-round">
        <p>Click each badge to see detailed services.</p>
          <button @click="showSap"><img src="sap.png"></button>
          <div v-if="sap == true">
             <p><b>Setup of your multi-account AWS security and compliance best practices and Automate ongoing policy management.</b></p>
             <ul>
              <li>provide identity management</li>
                <li>federate access to accounts</li>
                <li>centralize logging</li>
                <li>establish cross-account security audits</li>
                <li>define workflows for provisioning accounts</li>
                <li>implement account baselines with network configurations</li>
                <li>provide you with an integrated dashboard</li>
                <li>top-level summary of policies applied to your AWS environment</li>
                <li>view details on the accounts provisioned</li>
                <li>guardrails enabled across your accounts</li>
                <li>account level status for compliance with your guardrais</li>
             </ul>
          </div>
          <button @click="showDops"><img src="devops.png"></button>
          <div v-if="dops == true">
             <p><b>Set up CI/CD and automation.</b></p>
             <ul>
                <li>Implement and manage continuous delivery systems and methodologies on AWS</li>
                <li>Implement and automate security controls, governance processes, and compliance validation</li>
                <li>Define and deploy monitoring, metrics, and logging systems on AWS</li>
                <li>Implement systems that are highly available, scalable, and self-healing on the AWS platform</li>
                <li>Design, manage, and maintain tools to automate operational processes</li>
             </ul>
          </div>
          <button @click="showSec"><img src="security.png"></button>
          <div v-if="sec == true">
             <p><b>Setup of your multi-account AWS security and compliance best practices and Automate ongoing policy management.</b></p>
             <ul>
               <li>Create high-level rules, called guardrails.</li>
               <li>Enforce your policies using service control policies (SCPs).</li>
               <li>Detect policy violations using AWS Config rules.</li>
               <li>Provide a summary report of how each account conforms to your enabled policies.</li>
             </ul>
          </div>
          <button @click="showMl"><img src="ml.png"></button>
          <div v-if="ml == true">
             <p><b>Set up centralized summaries of all you AWS accounts.</b></p>
             <ul>
               <li>Select and justify the appropriate ML approach for a given business problem</li>
                <li>Identify appropriate AWS services to implement ML solutions</li>
                <li>Design and implement scalable, cost-optimized, reliable, and secure ML solutions</li>
             </ul>
          </div>
          <button @click="showBd"><img src="bigdata.png"></button>
          <div v-if="bd == true">
             <p><b>Set up Big Data & Machine Learning Pipelines</b></p>
           <ul>
                <li>Implement core AWS Big Data services according to basic architecture best practices</li>
                <li>Design and maintain Big Data</li>
                <li>Leverage tools to automate data analysis</li>
                <li>Experience in designing a scalable and cost-effective architecture to process data</li>
                <li>Select and justify the appropriate ML approach for a given business problem</li>
                <li>Identify appropriate AWS services to implement ML solutions</li>
                <li>Design and implement scalable, cost-optimized, reliable, and secure ML solutions</li>
          </ul>
          </div>
          <button @click="showNet"><img src="network.png"></button>
          <div v-if="net == true">
             <p><b>Set up Network</b></p>
           <ul>
                <li>Design, develop, and deploy cloud-based solutions using AWS</li>
                <li>Implement core AWS services according to basic architecture best practices</li>
                <li>Design and maintain network architecture for all AWS services</li>
                <li>Leverage tools to automate AWS networking tasks</li>
           </ul>
          </div>
    </div>
  
</template>
    
    
<script>
export default {
    name: 'Services',
    data() {
    return {
      sap: false,
      dops: false,
      sec: false,
      ml: false,
      bd: false,
      net: false
    };
    },
    methods: {
        showSap() {
            this.sap = !this.sap;
            },
        showDops() {
            this.dops = !this.dops;
            },
        showSec() {
            this.sec = !this.sec;
            },
        showMl() {
            this.ml = !this.ml;
            },
        showBd() {
            this.bd = !this.bd;
            },
        showNet() {
            this.net = !this.net;
            }
    }
};
</script>

 <style>
 #img {
  width: 200px;
  height: 200px;
}
.hover {
  background-color: blue;
  
}
  </style>